import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, forkJoin, Observable, retry, throwError } from 'rxjs';
import { SessionStorageService } from './storage.service';
import { UserService } from './user.service';

@Injectable({
	providedIn: 'root',
})
export class SalesService {
	// private headers: HttpHeaders;
	private accountId: string = 'ad0e483f-2a51-4e33-b5d9-4c69d44d88f7'; // <-- demowebshop    // 0fc68c5b-f142-4619-bfb3-65f5a5ce1fee

	constructor(
		private httpClient: HttpClient,
		private sessionStorageService: SessionStorageService,
		private userService: UserService,
	) {
		// this.headers = new HttpHeaders({
		//   Authorization: 'Bearer ' + this.sessionStorageService.get('User.Authorization'),
		//   'x-account-id': this.accountId,
		// });
	}

	private headers() {
		const accountId: string = this.userService.account.id;
		const token: string = this.sessionStorageService.get('User.Authorization');
		return new HttpHeaders({
			Authorization: `Bearer ${token}`,
			'x-account-id': accountId,
		});
	}

	calculatePosition(bomParameters: IBOMParameters, engineId: string, externalGroupKey: string): Observable<any> {
		const bomConfiguration: IBOMConfiguration = {
			timeout: 5,
			drawingEnabled: false,
			type: 'vip',
			externalGroupKey,
			configuration: bomParameters,
		};
		console.log(JSON.stringify(bomConfiguration));
		return this.httpClient
			.post(`${environment.awsEnvUri}/bom/engines/${engineId}/calculations`, bomConfiguration, {
				headers: this.headers(),
			})
			.pipe(retry(1), catchError(this.handleError));
	}

	getUserOrders(limit: number = 10, offset: number = 0, sortDirection: string = 'DESC'): Observable<object> {
		// console.log('cjs', this.sessionStorageService.get('User.Authorization'));
		// let data: IOrder[] = [];
		return this.httpClient.get(`${environment.awsEnvUri}/sales/orders?limit=${limit}&offset=${offset}&order=${sortDirection}`, {
			headers: this.headers(),
		});
	}

	getUserOrder(orderId: string): Observable<object> {
		return this.httpClient.get(`${environment.awsEnvUri}/sales/orders/${orderId}`, {
			headers: this.headers(),
		});
	}

	getOrderPositions(orderId: string): Observable<object> {
		return this.httpClient.get(`${environment.awsEnvUri}/sales/orders/${orderId}/positions`, {
			headers: this.headers(),
		});
	}

	getOrderCustomer(orderId: string): Observable<object> {
		return this.httpClient.get(`${environment.awsEnvUri}/sales/orders/${orderId}/customers`, {
			headers: this.headers(),
		});
	}

	getPositionRaw(calcRef: string, engineId?: string): Observable<object> {
		const userAcc = JSON.parse(this.sessionStorageService.get('User.Account'));
		const defaultEngine = userAcc.defaultEngine;
		const engine = engineId || defaultEngine;

		// Currently no good way to get the correct EngineId for a calcRef?
		// Going to use the defaultEngine for an Account for now, or an input engineId
		return this.httpClient.get(`${environment.awsEnvUri}/bom/engines/${engine}/calculations/${calcRef}`, {
			headers: this.headers(),
		});
	}

	getDefaultEngine(organizationId: string, accountId: string): Observable<object> {
		return this.httpClient.get(`${environment.awsEnvUri}/iam/organizations/${organizationId}/accounts/${accountId}`, {
			headers: this.headers(),
		});
	}

	getOrderAll(orderId: string): Observable<any> {
		return forkJoin([this.getUserOrder(orderId), this.getOrderPositions(orderId), this.getOrderCustomer(orderId)]);
	}

	private handleError(error: { error: { message: string }; status: any; message: any }) {
		console.log('http error', error);
		let errorMessage = '';
		if (error.error instanceof ErrorEvent) {
			// Get client-side error
			errorMessage = error.error.message;
		} else {
			// Get server-side error
			errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
		}
		if (error.status !== 403) {
			console.log(errorMessage);
			return throwError(() => new Error(errorMessage));
		}
		return [];
	}
}

export interface IBOMParameters {
	Model: string;
	Width: number;
	Height: number;
}

export interface IBOMConfiguration {
	type: string;
	timeout: number;
	drawingEnabled: boolean;
	externalGroupKey: string;
	configuration: IBOMParameters;
}
